import { render } from "./EditSubcategoryModal.vue?vue&type=template&id=86fd54fa"
import script from "./EditSubcategoryModal.vue?vue&type=script&lang=js"
export * from "./EditSubcategoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__